import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import { Document, Page } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 import axios from "axios";
import settings from '../../config/settings';
import DownloadingIcon from '@mui/icons-material/Downloading';
import PrintIcon from '@mui/icons-material/Print';
import BackHandIcon from '@mui/icons-material/BackHand';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import { useReactToPrint } from "react-to-print";
import { CButton } from '@coreui/react';
import CircularProgress from "@material-ui/core/CircularProgress";
import { handleApiError } from '../../session/session-expire';
import { useHistory } from "react-router";

  const toast_options = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

 
const AdvanceSearchFilePdf = ({ isOpen, onClose, fileUrl,selectedResult ,originalpdf,searchQuery,queryLogic}) => {
  const history = useHistory();
  const [canvasBackground, setCanvasBackground] = useState(null);
  const [renderAnnotationLayer, setRenderAnnotationLayer] = useState(true);
  const [renderForms, setRenderForms] = useState(true);
  const [renderMode, setRenderMode] = useState('canvas');
  const [renderTextLayer, setRenderTextLayer] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(10);  
   const [expandScreen, setExpandScreen] = useState(false);
  const [pageWidth, setPageWidth] = useState(850);
  const [pageHeight, setPageHeight] = useState(null);
  const [Isloader, setIsloader] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1.0);
 
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [panMode, setPanMode] = useState(false);
  const [highlightedText, setHighlightedText] = useState([]);
   const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef });

  const handlePdfLoadSuccess = async (pdf) => {
     setTotalPages(pdf.numPages);
    setTotalPages((numPages)=>numPages)
    if (searchQuery) {
      const highlights = await findQueryInPdf(pdf, searchQuery);
      setHighlightedText(highlights);
    }
  };

  const findQueryInPdf = async (pdf, query) => {
    const matches = [];
     const page = await pdf.getPage(1); 
     const textContent = await page.getTextContent();
     const text = textContent.items.map((item) => item.str).join(" ");
        if (text.includes(query)) {
      matches.push({ page: 1, text });
    }    
    return matches;
  };
 
// const highlightText = (text, searchQuery) => {
//   if (!text || !searchQuery.general.trim()) return text;

//    const searchWords = searchQuery.general
//     .replace(/,/g, " ")  
//     .split(/\s+/)    
//     .filter((word) => word.length > 0);  

//    const regex = new RegExp(`(${searchWords.join("|")})`, "gi");

//    return text.split(regex).map((part, index) =>
//     regex.test(part) ? (
//       <span
//         key={index}
//         style={{
//           backgroundColor: "#ffff00",
//           display: "inline",
//           padding: "0",
//           margin: "0",
//           color:'#000'
//         }}
//       >
//         {part}
//       </span>
//     ) : (
//       part
//     )
//   );
// };

// const highlightText = (text, searchQuery, queryLogic) => {
//   if (!text || !searchQuery.general.trim()) return text;

//   const escapeSpecialChars = (string) => {
//       return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//   };

//   const matchWholeWords = (text, searchWords) => {
//       const wordBoundaryRegex = `\\b(${searchWords.join("|")})\\b`;  
//       const regex = new RegExp(wordBoundaryRegex, "gi");

//       return text.split(regex).map((part, index) =>
//           regex.test(part) ? (
//               <span
//                   key={index}
//                   style={{
//                       backgroundColor: "#ffff00",
//                       display: "inline",
//                       padding: "0",
//                       margin: "0",
//                       color:'#000'
//                   }}
//               >
//                   {part}
//               </span>
//           ) : (
//               part
//           )
//       );
//   };

//   if (queryLogic === "EXACT MATCH") {
//       // Exact Match Logic: Treat the entire query as a single search term.
//       const escapedSearchQuery = escapeSpecialChars(searchQuery.general.trim());
//       return matchWholeWords(text, [escapedSearchQuery]);
//   } else if (queryLogic === "KEYWORD MATCH") {
//       // Keyword Match Logic: Split into keywords or phrases.
//       const searchWords = searchQuery.general.includes(',')
//           ? searchQuery.general.split(',').map((phrase) => phrase.trim()) // Split by commas for phrases
//           : searchQuery.general.split(/\s+/).map((word) => word.trim()); // Split by spaces for words

//       const escapedWords = searchWords.map((word) => escapeSpecialChars(word));
//       return matchWholeWords(text, escapedWords);
//   }

//   return text;
// };
 
const highlightText = (text, searchQuery, queryLogic) => {
  if (!text || !searchQuery.general.trim()) return text;

  const escapeSpecialChars = (string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const matchWholeWords = (text, searchWords) => {
    const wordBoundaryRegex = `\\b(${searchWords.join("|")})\\b`;
    const regex = new RegExp(wordBoundaryRegex, "gi");

    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#ffff00",
            display: "inline",
            padding: "0",
            margin: "0",
            color: "#000",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  if (queryLogic === "EXACT MATCH") {
    const escapedSearchQuery = escapeSpecialChars(searchQuery.general.trim());
    return matchWholeWords(text, [escapedSearchQuery]);
  } else if (queryLogic === "KEYWORD MATCH") {
    const searchWords = searchQuery.general.includes(",")
      ? searchQuery.general.split(",").map((phrase) => phrase.trim())
      : searchQuery.general.split(/\s+/).map((word) => word.trim());

    const escapedWords = searchWords.map((word) => escapeSpecialChars(word));
    return matchWholeWords(text, escapedWords);
  }

  return text;
};



      const handleMouseDown = (e) => {
    if (!panMode) return;
    setIsDragging(true);
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (isDragging && panMode) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const togglePanMode = () => {
     setPanMode(true)
   };

  const adsclickicon=()=>{
    setPanMode(false)
  }
   const getPageProps = () => ({
    canvasBackground,
    className: 'custom-classname-page',
    renderAnnotationLayer,
    renderForms,
    renderMode,
    renderTextLayer,
  });

  const pageProps = getPageProps();

  const pageDownClicked = () => {
    if (pageNo > 1) {
      const updatedNum = pageNo - 1;
      setPageNo(updatedNum);
    } else {
      toast.info("You are already on the first page!", toast_options);
    }
  };

  const pageUpClicked = () => {
    if (pageNo < totalPages) {
      const updatedNum = pageNo + 1;
      setPageNo(updatedNum);
    } else {
      toast.info("You are already on the last page!", toast_options);
    }
  };

  const pageNumberClicked = (data) => {
    if (data <= totalPages && data >= 1) {
      setPageNo(data);
    } else {
      toast.info(
        data > totalPages
          ? "You are already on the last page!"
          : "Invalid page number!",
        toast_options
      );
    }
  };
 
  const expandPdf = () => {
    let wwidth= window.innerWidth;
    let wheight= window.innerHeight;
     setExpandScreen(!expandScreen)
   
     if (!expandScreen) {
       setPageWidth(wwidth)
       setPageHeight(wheight)
     }
    else{
      setPageWidth(850)
      setPageHeight()
     }
  }
 
  const zoomIn = () => {
    if (zoomLevel < 3) {
      setZoomLevel((prevZoom) => prevZoom + 0.1);
    } else {
      toast.warn('Maximum zoom reached', toast_options);
    }
  };

  const zoomOut = () => {
    if (zoomLevel > 0.5) {
      setZoomLevel((prevZoom) => prevZoom - 0.1);
    } else {
      toast.warn('Minimum zoom reached', toast_options);
    }
  };
  const handleDownload = () => {
      const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${fileUrl}`;
     link.download = `${selectedResult.original_filename}`; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
 
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
};
 
  const handleOriginalPdfFile = async () => {
    setIsloader(true)
     try {
       if (!originalpdf?.path || !originalpdf?.url) {
        console.error("Invalid original PDF data");
        return;
      }
  
       const param = {
        filePath: originalpdf.path.replace("pages/", ""),
        fileName: originalpdf.url,
      };     
       const apiResponse = await axios.post(
        `${settings.serverUrl}/getSearchPdfFile`,
        param,
        { headers }  
      );
  
       const results = apiResponse?.data?.result?.base64Str;
  
      if (!results) {
        console.error("Error: Base64 string not found in API response");
        return;
      }
      setIsloader(false) 
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${results}`; 
      link.download = `${selectedResult.original_filename}`;  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
       

    } catch (error) {
      console.error("Error fetching PDF:", error.message);
      handleApiError(error, history);
    }
  };
  
  useEffect(() => {
    setPageWidth(850)
    setExpandScreen(false);  

   },[fileUrl])

  
  return (
    <Drawer
    className='drawer_pdf_box'
      anchor="right"
      open={isOpen}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0)',
         },
      }}
    >
    
<div style={{display:'flex',justifyContent:'space-between',backgroundColor:'#FAFAFA',
padding:'10px',border:'1px solid gray'}}>

<div style={{display:'flex',gap:'30px',alignItems:'center',marginLeft:'15px'}}>
<div onClick={() => expandPdf()} style={{cursor:'pointer' }}>
          
          {expandScreen ?  
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="Outline" viewBox="0 0 24 24" ><path d="M7.293,2.091,5.4,3.985,1.707.293A1,1,0,0,0,.293,1.707L3.985,5.4,2.091,7.293A1,1,0,0,0,2.8,9H7.564A1.436,1.436,0,0,0,9,7.564V2.8A1,1,0,0,0,7.293,2.091Z"/><path d="M20.015,18.6l1.894-1.894A1,1,0,0,0,21.2,15H16.436A1.436,1.436,0,0,0,15,16.436V21.2a1,1,0,0,0,1.707.708L18.6,20.015l3.692,3.692a1,1,0,0,0,1.414-1.414Z"/><path d="M16.436,9H21.2a1,1,0,0,0,.708-1.707L20.015,5.4l3.692-3.692A1,1,0,0,0,22.293.293L18.6,3.985,16.707,2.091A1,1,0,0,0,15,2.8V7.564A1.436,1.436,0,0,0,16.436,9Z"/><path d="M7.564,15H2.8a1,1,0,0,0-.708,1.707L3.985,18.6.293,22.293a1,1,0,1,0,1.414,1.414L5.4,20.015l1.894,1.894A1,1,0,0,0,9,21.2V16.436A1.436,1.436,0,0,0,7.564,15Z"/></svg>
        
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="Bold" viewBox="0 0 24 24" ><path d="M22.5,15.5A1.5,1.5,0,0,0,21,17v1.5A2.5,2.5,0,0,1,18.5,21H17a1.5,1.5,0,0,0,0,3h1.5A5.506,5.506,0,0,0,24,18.5V17A1.5,1.5,0,0,0,22.5,15.5Z"/><path d="M7,0H5.5A5.506,5.506,0,0,0,0,5.5V7A1.5,1.5,0,0,0,3,7V5.5A2.5,2.5,0,0,1,5.5,3H7A1.5,1.5,0,0,0,7,0Z"/><path d="M7,21H5.5A2.5,2.5,0,0,1,3,18.5V17a1.5,1.5,0,0,0-3,0v1.5A5.506,5.506,0,0,0,5.5,24H7a1.5,1.5,0,0,0,0-3Z"/><path d="M18.5,0H17a1.5,1.5,0,0,0,0,3h1.5A2.5,2.5,0,0,1,21,5.5V7a1.5,1.5,0,0,0,3,0V5.5A5.506,5.506,0,0,0,18.5,0Z"/></svg>
      
          }
         
                </div>
                
                <div onClick={() => zoomIn()} style={{cursor:'pointer' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  id="Bold"  viewBox="0 0 512 512" >
      <path d="M288,192h-32v-32c0-17.673-14.327-32-32-32s-32,14.327-32,32v32h-32c-17.673,0-32,14.327-32,32s14.327,32,32,32h32v32  c0,17.673,14.327,32,32,32s32-14.327,32-32v-32h32c17.673,0,32-14.327,32-32S305.673,192,288,192z"/>
      <path d="M502.661,457.569l-99.046-99.067c74.18-99.06,54.01-239.499-45.05-313.678S119.067-9.187,44.887,89.873  s-54.01,239.499,45.05,313.678c79.587,59.597,188.929,59.623,268.544,0.063l99.088,99.088c12.452,12.452,32.64,12.452,45.092,0  c12.452-12.452,12.452-32.64,0-45.092L502.661,457.569z M225.116,384.49c-88.02,0-159.374-71.354-159.374-159.374  S137.097,65.742,225.116,65.742s159.374,71.354,159.374,159.374C384.397,313.097,313.098,384.397,225.116,384.49z"/>
      </svg>
      
               </div>
                <div onClick={() => zoomOut()} style={{cursor:'pointer' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  id="Bold"  viewBox="0 0 512 512" >
      <path d="M288,192H160c-17.673,0-32,14.327-32,32s14.327,32,32,32h128c17.673,0,32-14.327,32-32S305.673,192,288,192z"/>
      <path d="M502.661,457.569l-99.046-99.067c74.18-99.06,54.01-239.499-45.05-313.678S119.067-9.187,44.887,89.873  s-54.01,239.499,45.05,313.678c79.587,59.597,188.929,59.623,268.544,0.063l99.088,99.088c12.452,12.452,32.64,12.452,45.092,0  c12.452-12.452,12.452-32.64,0-45.092L502.661,457.569z M225.116,384.49c-88.02,0-159.374-71.354-159.374-159.374  S137.097,65.742,225.116,65.742s159.374,71.354,159.374,159.374C384.397,313.097,313.098,384.397,225.116,384.49z"/>
      </svg>
       
               </div>
               <PrintIcon style={{ cursor: 'pointer' }} onClick={() => reactToPrintFn()} />

</div>

<div style={{display:'flex',gap:'30px',alignItems:'center',marginRight:'10px', }}>
  
  <AdsClickIcon onClick={adsclickicon}/>
  <BackHandIcon
        onClick={togglePanMode}
        style={{
          cursor: "pointer",
          color: panMode ? "gray" : "inherit", 
        }}
      />
        <DownloadingIcon style={{cursor:'pointer'}}  onClick={()=>handleDownload()}/>
       <CButton onClick={()=>handleOriginalPdfFile()} style={{padding: '4px 8px 4px 8px',fontSize:'13px',fontWeight:600,background: '#fff',  boxShadow:'1px 1px 3px rgba(0,0,0,0.4)'}}>
       <i class="fa fa-download" aria-hidden="true"></i> Original PDF {Isloader && (
           <CircularProgress
             size={10}
             style={{ color: '#000'}}
           />
         )}</CButton>
    </div>
 
</div>      
      <Box
      
        sx={{
          width: pageWidth,
     height: '100vh',
     display: 'flex', 
    justifyContent: 'center',  
    alignItems: 'center',  
     backgroundColor:'#aeaeae',
    border:'1px solid gray',
     overflow: 'hidden',  
     
         }}
                 onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onMouseDown={handleMouseDown}
        style={{
          cursor: panMode
            ? isDragging
              ? "grabbing"
              : "grab"
            : "default",
        }}
      >
     <div style={{
      
      height:'100%',
            transform: `translate(${position.x}px, ${position.y}px)`,
            transition: isDragging ? "none" : "transform 0.1s ease-out",
     }}
     ref={contentRef} > 
     {fileUrl ? (
  <Document
    file={`data:application/pdf;base64,${fileUrl}`}
    onLoadSuccess={({ numPages }) => setTotalPages(numPages)}
  >
    {Array.from({ length: totalPages }, (_, index) => (
      <Page
        key={index + 1}
        pageNumber={index + 1}
        scale={zoomLevel}
        customTextRenderer={({ str }) =>
          searchQuery ? highlightText(str, searchQuery, queryLogic) : str
        }
      />
    ))}
  </Document>
) : (
  <p>No file available to display</p>
)}

        {/* {fileUrl ? (
          <Document
      file={`data:application/pdf;base64,${fileUrl}`}
      onLoadSuccess={handlePdfLoadSuccess}
    >
      <Page
        pageNumber={pageNo}
        scale={zoomLevel}
        customTextRenderer={({ str, itemIndex }) =>
          searchQuery ? highlightText(str, searchQuery, queryLogic) : str
        }
      />
    </Document>
   
        ) : (
          <p>No file available to display</p>
        )} */}
        </div>
      </Box>
            <Divider />
      {/* <div className="custom_pagination">
        <p onClick={pageDownClicked}>
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </p>
        {Array.from({ length: totalPages }).map((_, index) => {
          const displayRange = pageNo <= totalPages - 3
            ? pageNo + 3 >= index + 1 && pageNo - 1 <= index
            : totalPages - 3 <= index;

          return displayRange ? (
            <p
              key={index}
              className={index + 1 === pageNo ? "active" : ""}
              onClick={() => pageNumberClicked(index + 1)}
            >
              {index + 1}
            </p>
          ) : null;
        })}
        <p>...</p>
        <p onClick={() => pageNumberClicked(totalPages)}>{totalPages}</p>

        <p onClick={pageUpClicked}>
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </p>

      </div> */}
      <ToastContainer />
    </Drawer>
  );
};

export default AdvanceSearchFilePdf;